import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TrafficInfoResponse } from './traffic-info-types';

const trafficInfoUrl = process.env.REACT_APP_TRAFFIC_INFO_URL;

export function useTrafficInfoApi(): UseQueryResult<TrafficInfoResponse> {
  if (!trafficInfoUrl) {
    throw new Error('TRAFFIC_INFO_URL environment variable is not set');
  }

  return useQuery({
    queryKey: ['trafficInfo'],
    queryFn: async () => {
      const response = await fetch(trafficInfoUrl);
      return await response.json();
    },
  });
}
